import * as React from 'react';

import { DataContext } from '../context';

export const useData = () => {
  const { scores, setScores, details, setDetails } =
    React.useContext(DataContext);
  return {
    scores,
    setScores,
    details,
    setDetails,
  };
};
